<script setup lang="ts">
const emit = defineEmits<{
    close: [];
}>();
const items = [
    {
        title: 'صحت اطلاعات پرداخت‌کننده:',
        content:
            'مسئولیت وارد کردن شماره موبایل صحیح و انتخاب پرداخت‌کننده بر عهده کاربری است که لینک پرداخت را ارسال می‌کند. پیش از ارسال، از صحت شماره موبایل و هویت پرداخت‌کننده اطمینان حاصل کنید.',
    },
    {
        title: 'محرمانگی لینک:',
        content:
            'محرمانگی و حفظ لینک پرداخت بر عهده مسافر است. برای جلوگیری از سوءاستفاده اشخاص ناشناس، از اشتراک‌گذاری لینک در فضای عمومی یا در اختیار قرار دادن آن به دیگران خودداری کنید. در صورت دسترسی اشخاص ثالث به لینک، مسئولیت پیامدهای ناشی از آن بر عهده مسافر است و مستربلیط در این خصوص مسئولیتی نخواهد داشت.',
    },
    {
        title: 'اعتبار لینک پرداخت:',
        content:
            'لینک پرداخت تنها در مدت اعتبار تعیین‌شده قابل استفاده است. با توجه به لحظه‌ای بودن قیمت و ظرفیت اعلام‌شده از سوی ایرلاین، لازم است پرداخت در زودترین زمان ممکن و حداکثر در بازه تعیین شده انجام شود. در غیر این صورت، حتی در صورت موفق بودن پرداخت، به دلیل منقضی شدن اعتبار لینک، ممکن است بلیط صادر نشود یا شرایط خرید تغییر کند و مستربلیط در این خصوص مسئولیتی نخواهد داشت.',
    },
    {
        title: 'تغییر شرایط درخواست:',
        content:
            'در صورت تغییر مبلغ، شرایط یا وضعیت درخواست، ممکن است لینک پرداخت قبلی باطل شود و ادامه فرآیند نیازمند دریافت لینک جدید باشد.',
    },
    {
        title: 'وضعیت نهایی پرداخت:',
        content:
            'پرداخت زمانی موفق است که پیام «پرداخت موفق» به شما نمایش داده شود. صرف ورود به درگاه یا کسر مبلغ از حساب، به معنی موفق بودن پرداخت نیست. همچنین نمایش پیام «پرداخت موفق» به معنی صدور بلیط نیست. صدور آن منوط به نهایی شدن خرید و تأیید آن در سیستم مستربلیط است.',
    },
    {
        title: 'پرداخت اشتباه یا دسترسی اشخاص ثالث:',
        content:
            'مستربلیط مسئولیتی نسبت به پیامدهای ناشی از وارد کردن شماره موبایل اشتباه، انتخاب پرداخت‌کننده نامناسب یا اشتراک‌گذاری لینک با اشخاص غیرمرتبط نخواهد داشت.',
    },
];
</script>

<template>
    <mr-modal
        title="راهنمای ارسال لینک پرداخت"
        width="min(100vw - 32px, 440px)"
        @close="emit('close')"
    >
        <ul class="terms-list">
            <li v-for="({ title, content }, i) in items" :key="i">
                <mr-typography weight="500" type="p" color="black">
                    <mr-typography weight="700" type="span">
                        {{ title }}
                    </mr-typography>
                    {{ content }}
                </mr-typography>
            </li>
        </ul>
        <template #footer>
            <mr-button class="action" full-width @click="emit('close')">
                متوجه شدم
            </mr-button>
        </template>
    </mr-modal>
</template>

<style scoped lang="scss">
ul.terms-list {
    display: block;
    list-style: disc;
    padding-right: 15px;
    height: 306px;
    @include desktop-only {
        height: 419px;
    }
}

ul.terms-list > li {
    /* bullet comes from li */
    /* default */
    list-style: disc outside;
}
</style>
